import {
  DropdownOptions,
  FilterProvider,
  Flex,
  FormProvider,
  LocalCashTables,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  TooltipPopup,
} from 'dash-ui';
import MarketAreasTable from './MarketAreasTable';
import MarketAreasTopBar from '../components/MarketAreasTopBar/MarketAreasTopBar';
import SaveMarketAreaModal from '../components/SaveMarketAreaModal/SaveMarketAreaModal';
import { FormFieldsList } from 'pages/market-areas/MarketAreasPage.constants';
import DeleteMarketAreaModal from '../components/DeleteMarketAreaModal/DeleteMarketAreaModal';
import ConfirmationDeleteMarketAreaModal from '../components/ConfirmationDeleteMarketAreaModal/ConfirmationDeleteMarketAreaModal';

const MarketAreasPage = () => {
  return (
    <PaginationProvider storageTableName={LocalCashTables.MARKET_AREA}>
      <FormProvider fieldsList={FormFieldsList}>
        <FilterProvider>
          <SearchProvider>
            <SortProvider>
              <ModalProvider>
                <Flex flexDirection="column" w="100%">
                  <DropdownOptions />
                  <TooltipPopup />
                  <MarketAreasTopBar />
                  <SortProvider>
                    <MarketAreasTable />
                  </SortProvider>
                  <SaveMarketAreaModal />
                  <DeleteMarketAreaModal />
                  <ConfirmationDeleteMarketAreaModal />
                </Flex>
              </ModalProvider>
            </SortProvider>
          </SearchProvider>
        </FilterProvider>
      </FormProvider>
    </PaginationProvider>
  );
};

export default MarketAreasPage;
